var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeightView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.273,
    height: 24.001,
    viewBox: "0 0 16.273 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .height-view{fill:#9d9d9d}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1782",
    transform: "translate(-1150.416 -804.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4193",
    d: "M1166.2 804.207h-13.166a.49.49 0 0 0-.37.17l-2.129 2.475a.487.487 0 0 0-.119.319v16.549a.489.489 0 0 0 .489.489h15.3a.489.489 0 0 0 .489-.489V804.7a.489.489 0 0 0-.494-.493zm-.489 19.024h-14.318v-15.879l1.865-2.168h12.452z",
    className: "height-view"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4194",
    d: "M1153.135 809.439a.488.488 0 0 0 .489.489h1.775a.488.488 0 0 0 .489-.489v-1.831a.489.489 0 0 0-.978 0v1.342h-1.286a.488.488 0 0 0-.489.489z",
    className: "height-view",
    transform: "translate(-1.39 -1.489)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4195",
    d: "M1162.785 815.431h1.65v1.63a.338.338 0 0 0 .676 0v-1.63h1.65a.2.2 0 0 0 .165-.309l-1.988-2.972a.2.2 0 0 0-.331 0l-1.988 2.972a.2.2 0 0 0 .166.309z",
    className: "height-view",
    transform: "translate(-6.221 -4.015)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4196",
    d: "M1164.608 832.017a.2.2 0 0 0 .331 0l1.988-2.972a.2.2 0 0 0-.165-.31h-1.65V827.1a.338.338 0 0 0-.676 0v1.63h-1.65a.2.2 0 0 0-.165.31z",
    className: "height-view",
    transform: "translate(-6.221 -11.532)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeightView);
export default __webpack_public_path__ + "static/media/HeightView.57369ec7.svg";
export { ForwardRef as ReactComponent };